/**
 * Created by jiachenpan on
 */

export function isvalidUsername(str) {
    const valid_map = ['admin', 'editor']
    return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validateURL(textval) {
    const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return urlregex.test(textval)
}

/**
 * validate url
 * 带http https或不带http https开头的校验
 * @param url
 * @returns {boolean}
 */
export function validateWideURL(url) {
    const re = /^((https?|ftp):\/\/)?([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return re.test(url)
}

export function wideURLValidator(rule, value, callback) {
    if (value && !validateWideURL(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
};

/* 小写字母*/
export function validateLowerCase(str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
}

/**
 * 校验数字或字母
 * @param {string} code
 * @returns {boolean}
 */
export function validateCode(code) {
    return /^[0-9a-zA-Z]{1,}$/.test(code);
}

export function codeValidator(rule, value, callback) {
    if (value && !validateCode(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
};

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
}

/**
 * validate phone
 * 3-4位区号：大陆地区0开头，香港852，澳门853
 * 7-8位电话号码
 * @param phone
 * @returns {boolean}
 */
export function validatePhone(phone) {
    let regPone = null;
    let mobile = /^1(3|4|5|6|7|8|9)\d{9}$/; //最新16手机正则
    let tel = /^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/; //座机
    if (phone.charAt(0) == 0) {    // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
        regPone = tel;
    } else {
        regPone = mobile;
    }
    return regPone.test(phone)
}

/**
 * 手机号校验
 * @param phone
 * @returns {boolean}
 */
export function validateMobilePhone(phone) {
    return /^[1]{1}[0-9]{10}$/.test(phone);
}

/**
 * validate postalcode
 * @param code
 * @returns {boolean}
 */
export function validatePostalCode(code) {
    const re = /^\d{6}$/;
    return re.test(code);
}

/**
 * 校验身份证号
 * @param code
 * @returns {boolean}
 */
export function validateIDCard(code) {
    return /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(code);
}

/**
 * 校验港澳台身份证号
 * @param code
 * @returns {boolean}
 */
export function validateIDCard_HongKongandMacao(code) {
    return /^([A-Z]\d{6,10}(\(\w{1}\))?)$/.test(code);
}

/**
 * 校验台湾身份证号
 * @param code
 * @returns {boolean}
 */
export function validateIDCard_Taiwan(code) {
    return /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(code);
}

/**
 * 校验护照
 * @param code
 * @returns {boolean}
 */
export function validatePassPortCardCode(code) {
    return /^([a-zA-z]|[0-9]){5,17}$/.test(code);
}

/**
 * 校验出生证
 * @param code
 * @returns {boolean}
 */
export function validateBornCardCode(code) {
    return /^[a-zA-Z0-9]{5,21}$/.test(code);
}

/**
 * 校验银行卡号
 * @param code
 * @returns {boolean}
 */
export function validateBankCardCode(code) {
    return /^\d{13,}$/.test(code);
}

/**
 * 起始日期校验1
 * 1. 不得晚于当日
 * 2. 不得晚于结束日期
 * @param {date} startDate
 * @param {date} endDate
 * @param {boolean} ifCanEqual 起始日期是否可以等于结束日期
 * 
 */
export function validateStartDate(startDate, endDate, ifCanEqual = false) {
    if (!ifCanEqual) {
        return ((endDate ? startDate.getTime() > new Date(endDate) - 24 * 3600 * 1000 : false) || startDate.getTime() > Date.now())
    } else {
        return ((endDate ? startDate.getTime() > new Date(endDate) : false) || startDate.getTime() > Date.now())
    }
}

/**
 * 结束日期校验1
 * 1. 不得晚于当日
 * 2. 不得早于起始日期
 * @param {date} startDate
 * @param {date} endDate
 * @param {boolean} ifCanEqual 起始日期是否可以等于结束日期
 */
export function validateEndDate(startDate, endDate, ifCanEqual) {
    if (!ifCanEqual) {
        return ((startDate ? endDate.getTime() < new Date(startDate) : false) || endDate.getTime() > Date.now());
    } else {
        return ((startDate ? endDate.getTime() < new Date(startDate) - 24 * 3600 * 1000 : false) || endDate.getTime() > Date.now());
    }
}

/**
 * 起始日期校验2
 * 1. 不得晚于结束日期
 * @param {date} startDate
 * @param {date} endDate
 * @param {boolean} ifCanEqual 起始日期是否可以等于结束日期
 */
export function validateWideLyStartDate(startDate, endDate, ifCanEqual = false) {
    if (!ifCanEqual) {
        return (endDate ? (startDate.getTime() > new Date(endDate) - 24 * 3600 * 1000) : false)
    } else {
        return (endDate ? startDate.getTime() > new Date(endDate) : false)
    }
}

/**
 * 结束日期校验2
 * 1. 不得早于起始日期
 * @param {date} startDate
 * @param {date} endDate
 * @param {boolean} ifCanEqual 起始日期是否可以等于结束日期
 *
 */
export function validateWideLyEndDate(startDate, endDate, ifCanEqual = false) {
    if (!ifCanEqual) {
        return (startDate ? endDate.getTime() < new Date(startDate) : false)
    } else {
        return (startDate ? (endDate.getTime() < new Date(startDate) - 24 * 3600 * 1000) : false)
    }
}

/**
 * 校验数字
 * @param {string} num
 * @returns {boolean}
 */
export function validateNumber(num) {
    return /(^(-)?[0-9]{1}(\.[0-9]{1,})?$)|(^(-)?[1-9]{1}[0-9]{1,}(\.[0-9]{1,})?$)/.test(num);
}

export function numberValidator(rule, value, callback) {
    if (
        value && !validateNumber(value)
    ) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
};

/**
 * 校验版本号
 * @param {string} version
 * @returns {boolean}
 */
export function validateVersion(version) {
    return /^\d{1,}(\.\d{1,})*$/.test(version);
}

export function versionValidator(rule, value, callback) {
    if (
        value && !validateVersion(value)
    ) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
};

/**
 * 正整数校验
 * @param {number|string} num
 */
export function validatePositiveInteger(num) {
    return /(^[1-9]{1,}$)|(^[1-9]{1,}[0-9]{1,}$)/.test(num);
}

export function positiveInteger(rule, value, callback) {
    if (value && !validatePositiveInteger(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
};

/**
 * 年龄校验
 * @param {number|string} age
 */
export function validateAge(age) {
    return /^(?:[1-9][0-9]?|1[01][0-9]|120)$/.test(age);
}

export function ageValidator(rule, value, callback) {
    if (value && !validateAge(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
}

/**
 * 金额校验：整数或者保留一位或两位小数，大于1时第一位数不许为0，总数不许为0
 * @param {number|string} money
 */
export function validateMoney(money) {
    return /(^[0-9]{1}(\.[0-9]{1,2})?$)|(^[1-9]{1}[0-9]{1,}(\.[0-9]{1,2})?$)/.test(money) && parseFloat(money) !== 0;
}

export function moneyValidator(rule, value, callback) {
    if (value && !validateMoney(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
};

/**
 * 最多保留两位小数校验：整数或者保留一位或两位小数，大于1时第一位数不许为0
 * @param {number|string} money
 */
export function validateFloatingNumber(money) {
    return /(^[0-9]{1}(\.[0-9]{1,2})?$)|(^[1-9]{1}[0-9]{1,}(\.[0-9]{1,2})?$)/.test(money);
}

export function floatingNumberValidator(rule, value, callback) {
    if (value && !validateFloatingNumber(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
};

/**
 * 中文校验：必须全为中文
 * @param {string} str
 */
export function validateChinese(str) {
    return /^[\u4E00-\u9FA5\uF900-\uFA2D]{1,}$/.test(str);
}

export function ChineseValidator(rule, value, callback) {
    if (value && !validateChinese(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
}

/**
 * 中文校验：只需包含中文
 * @param {string} str
 */
export function validateChineseWidely(str) {
    return /[\u4E00-\u9FA5\uF900-\uFA2D]/g.test(str);
}

export function ChineseWidelyValidator(rule, value, callback) {
    if (value && !validateChineseWidely(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
}

/**
 * 中英文校验
 * @param {string} str
 */
export function validateChineseAndEnglish(str) {
    return /^[\u4E00-\u9FA5\uF900-\uFA2Da-zA-Z]{1,}$/.test(str);
}

export function ChineseAndEnglishValidator(rule, value, callback) {
    if (value && !validateChineseAndEnglish(value)) {
        callback(new Error(rule.message));
    } else {
        callback();
    }
}

/**
 * 中文校验
 * @param {string} str
 */
export function validateChinese1(rule, value, callback) {
    if (value) {
        if (/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(value)) {
            callback(new Error('不可输入中文'));
        } else {
            callback();
        }
    } else {
        callback();
    }
}

/**
 * 去除所有html标签只返回其中的文本
 * @param {string} htmlString
 *
 */
export function html2text(htmlString) {
    return htmlString.replace(/<[^>]*>|<\/[^>]*>/gm, "");
}